// src/providers/trpc.tsx
import { createTRPCReact } from "@trpc/react-query";
import { httpBatchLink } from "@trpc/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import superjson from "superjson";
import type { AppRouter } from "../../api/router";
import type { ReactNode } from "react";

export const trpc = createTRPCReact<AppRouter>();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 2,
      cacheTime: 1000 * 60 * 1,
      retry: 3,
      retryDelay: 1000,
      networkMode: 'always',
      refetchOnWindowFocus: true,
      refetchOnReconnect: true,
      refetchInterval: 2000,
    },
    mutations: {
      networkMode: 'always',
      retry: 3,
    },
  },
});

// ✅ CORRIGIDO: Retorna o domínio base SEM /api
function getApiUrl(): string {
  if (import.meta.env.VITE_API_URL) {
    return import.meta.env.VITE_API_URL;
  }
  
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    const protocol = window.location.protocol;
    
    if (host === 'localhost' || host === '127.0.0.1') {
      return 'http://localhost:3001';
    }
    
    // ✅ Retorna o domínio base (sem /api)
    return `${protocol}//${host}`;
  }
  
  return 'http://localhost:3001';
}

const API_URL = getApiUrl();
console.log(`🔗 API URL: ${API_URL}`);

const trpcClient = trpc.createClient({
  transformer: superjson,
  links: [
    httpBatchLink({
      // ✅ URL correta: BASE + /api/trpc
      url: `${API_URL}/api/trpc`,
      fetch(input, init) {
        return globalThis.fetch(input, { ...(init ?? {}), credentials: "include" });
      },
    }),
  ],
});

export function TRPCProvider({ children }: { children: ReactNode }) {
  return (
    <trpc.Provider client={trpcClient} queryClient={queryClient}>
      <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
    </trpc.Provider>
  );
}